<template>
  <div class="page-case-list">
    <div class="page-case-list__header">
      <h3 class="page-case-list__title">全部合作案例</h3>
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleBtnAddCaseClick">新建</el-button>
    </div>
    <div class="page-case-list__body">
      <el-table class="page-case-list__table" :data="cases" style="width: 100%" border>
        <el-table-column label="合作案例名称" width="400">
          <template slot-scope="scope">
            <div class="page-case-list__media">
              <img :src="scope.row.imageList | showFirstImage" :alt="scope.row.name">
              <span>{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="index" label="排序"></el-table-column>
        <el-table-column prop="isShowInHome" label="首页是否显示">
          <template slot-scope="scope">{{ scope.row.isShowInHome ? '是' : '否' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleBtnDeleteCaseClick(scope.row.id)">删除</el-button>
            <el-button type="text" size="small" @click="handleBtnEditCaseClick(scope.row.id)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-case-list__pagination" v-if="total > limit">
        <el-pagination layout="prev, pager, next" :total="total" @current-change="handlePageChange" background></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-case-list',

  data () {
    return {
      offset: 0,
      limit: 15
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    },

    total () {
      return this.$store.state.story.total
    },

    cases () {
      return this.$store.state.story.cases
    }
  },

  created () {
    this.getCases()
  },

  methods: {
    getCases () {
      this.$store.dispatch('getCases', {
        params: { userId: this.user.id },
        query: {
          offset: this.offset * this.limit,
          limit: this.limit
        }
      })
    },

    deleteCase (id, cb) {
      this.$store.dispatch('deleteCase', {
        params: {
          userId: this.user.id,
          caseId: id
        }
      }).then(() => {
        cb(null)
      }).catch(error => {
        cb(error)
      })
    },

    handleBtnAddCaseClick () {
      this.$router.push({ name: 'CaseEdit' })
    },

    handleBtnEditCaseClick (id) {
      this.$router.push({ name: 'CaseEdit', query: { id } })
    },

    handleBtnDeleteCaseClick (id) {
      this.$confirm('此操作将删除该合作案例, 是否继续?', '提示', {
        type: 'warning',
        showClose: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.deleteCase(id, (error) => {
          if (error) {
            this.$message({
              type: 'warning',
              message: '删除合作案例失败!'
            })
          } else {
            this.getCases()
            this.$message({
              type: 'success',
              message: '删除合作案例成功!'
            })
          }
        })
      }).catch(() => {
        // No handler
      })
    },

    handlePageChange (page) {
      this.offset = --page
      this.getCases()
    }
  }
}
</script>

<style lang="scss">
.page-case-list {
  min-height: 100%;
  background-color: #fff;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid $border-color;
  }

  &__body {
    padding: 15px;
  }

  &__title {
    margin: 0;
  }

  &__table th {
    background-color: #f8f8f8;
  }

  &__media {
    display: flex;
    align-items: center;

    img {
      width: 118px;
      height: 118px;
      border-radius: 4px;
      object-fit: cover;
    }

    span {
      flex: 1;
      margin-left: 10px;
    }
  }

  &__pagination {
    padding-top: 30px;
    padding-bottom: 15px;
    text-align: right;
  }
}
</style>
